import PropTypes from "prop-types"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import Confirmation from "components/ui/confirmation"
import withGeo from "hoc/with-geo"

const LocaleDialog = ({
  geoCookie,
  geoCookieDefault,
  selectedGeoCookie,
  setSelectedGeo,
  showCountryModal,
  toggleCountryModal,
}) => {
  const location = useLocation()
  const currentCountry = sl.config.site_country_for_analytics
  const path = `${location.pathname === "/" ? "" : location.pathname}`
  let params = `${location.search ? `${location.search}&` : "?"}`
  if (typeof URLSearchParams !== "undefined") {
    params = new URLSearchParams(location.search)
    params.delete("geo")
    params.delete("locale")
    params = `${params.toString() ? `?${params.toString()}&` : "?"}`
  }

  // TODO: When we enable country subfolders for Jewlr, we need to add extra condition here
  // to check for us site: || sl.config.site_country == "us"
  let countrySubfolder = sl.basename != ""

  const countries = {
    au: {
      ian: "Australia",
      title: "Australia",
      url: `https://${sl.config.env === "production" ? "www" : sl.config.env}.${
        countrySubfolder ? "jewlr.com/au" : "jewlr.com/au"
      }${path}${params}geo=AU`,
    },
    ca: {
      ian: "Canada",
      title: "Canada",
      url: `https://${sl.config.env === "production" ? "www" : sl.config.env}.${
        countrySubfolder ? "jewlr.com/ca" : "jewlr.com/ca"
      }${path}${params}geo=CA`,
    },
    gb: {
      ian: "UK",
      title: "the UK",
      url: `https://${sl.config.env === "production" ? "www" : sl.config.env}.${
        countrySubfolder ? "jewlr.com/uk" : "jewlr.com/uk"
      }${path}${params}geo=GB`,
    },
    us: {
      ian: "US",
      title: "the US",
      url: `https://${
        sl.config.env === "production" ? "www" : sl.config.env
      }.jewlr.com${path}${params}geo=US`,
    },
  }

  useEffect(() => {
    toggleCountryModal(
      geoCookieDefault &&
        geoCookie !== currentCountry &&
        (!selectedGeoCookie || selectedGeoCookie !== currentCountry) &&
        Object.keys(countries).includes(geoCookie.toLowerCase())
    )
  }, [geoCookie, selectedGeoCookie])

  const country = countries[geoCookie.toLowerCase()]

  if (!country) {
    return ""
  }

  return (
    <Confirmation
      cancelText={`Keep shopping in ${
        countries[currentCountry.toLowerCase()].title
      }`}
      confirmText={`Start shopping in ${country.ian}`}
      onCancel={() => {
        setSelectedGeo(currentCountry)
        toggleCountryModal(false)
      }}
      onConfirm={() => {
        window.location.href = country.url
      }}
      show={showCountryModal}
      title={
        <>
          It looks like you&apos;re <br />
          in {country.title}!
        </>
      }
    />
  )
}

LocaleDialog.propTypes = {
  geoCookie: PropTypes.string,
  geoCookieDefault: PropTypes.string,
  selectedGeoCookie: PropTypes.string,
  setSelectedGeo: PropTypes.func,
  showCountryModal: PropTypes.bool,
  toggleCountryModal: PropTypes.func,
}

export default withGeo(LocaleDialog)
